import { z } from "zod";
import { ZodPassword } from "../../zod-types/zod-password";

export const patchUserPasswordSchema = z
	.object({
		password: ZodPassword,
		confirmPassword: z.string(),
	})
	.superRefine((data, context) => {
		if (data.password !== data.confirmPassword) {
			context.addIssue({
				code: z.ZodIssueCode.custom,
				message: "Passwords do not match",
				path: ["confirmPassword"],
			});
		}
	});

export type PatchUserPasswordForm = z.infer<typeof patchUserPasswordSchema>;
